'use client';

import React from 'react';
import { useLease } from '@/components/context/LeaseContext';
import { Image } from '@/components/shared';
import { useTranslations } from 'next-intl';
import { Typography } from '@mui/material';

const LeaseSpecifications = () => {
    const { leases, selectedLease } = useLease();

    const t = useTranslations('pages.request_website_lease');

    return (
        <div className="flex flex-col gap-2 mt-10">
            <div className='flex items-center gap-x-2 w-fit'>
                <Image
                    src='Icons/Badge_yfr86o'
                    alt='Certificates'
                    width={24}
                    height={24}
                />

                <Typography variant='body1' className='text-primary-gray-950 max-w-lg'>{t(`request_subscription.tags.0`)}</Typography>
            </div>
            <div className='flex items-center gap-x-2 w-fit'>
                <Image
                    src='Icons/Badge_yfr86o'
                    alt='Certificates'
                    width={24}
                    height={24}
                />

                <Typography variant='body1' className='text-primary-gray-950 max-w-lg'>{t(`request_subscription.tags.1`, {
                    package: leases[selectedLease].name
                })}</Typography>
            </div>
            <div className='flex items-center gap-x-2 w-fit'>
                <Image
                    src='Icons/Badge_yfr86o'
                    alt='Certificates'
                    width={24}
                    height={24}
                />

                <Typography variant='body1' className='text-primary-gray-950 max-w-lg'>{t(`request_subscription.tags.2`, {
                    price: leases[selectedLease].price
                })}</Typography>
            </div>
            <div className='flex items-center gap-x-2 w-fit'>
                <Image
                    src='Icons/Badge_yfr86o'
                    alt='Certificates'
                    width={24}
                    height={24}
                />

                <Typography variant='body1' className='text-primary-gray-950 max-w-lg'>{t(`request_subscription.tags.3`)}</Typography>
            </div>
        </div>
    );
}

export default LeaseSpecifications;